import React from 'react';
import { ClockIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
export function CountdownBar() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  return <div className="sticky top-0 z-50 w-full bg-blush-500 text-white" data-id="element-39" data-mp="2vejwgdc3ru3w">
      <div className="mx-auto flex max-w-5xl flex-col items-center justify-center gap-1 px-4 py-2.5 text-center sm:flex-row sm:gap-3" data-id="element-40" data-mp="2vcpbx04qu40c">
        <p className="flex items-center gap-2 text-sm font-bold sm:text-base" data-id="element-41" data-mp="2menf6ws1lxiv">
          <ClockIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-42" data-mp="2hfk7f4kohd77" />
          Final hours to grab this price
        </p>
        <span className="hidden text-blush-200 sm:inline" aria-hidden="true" data-id="element-43" data-mp="2cfftnmb5mwko">
          •
        </span>
        <p className="text-xs text-blush-100 sm:text-sm" data-id="element-44" data-mp="28fnpdlssncl4">
          Once the countdown ends, this special offer is gone.
        </p>
        <div className="mt-1 flex items-center gap-1 font-display text-base font-bold tabular-nums sm:mt-0 sm:ml-1" data-id="element-45" data-mp="ao1inliomn3m">
          <TimeBox value={hours} label="h" data-id="element-46" data-mp="6ler7lpxb46y" />
          <span aria-hidden="true" data-id="element-47" data-mp="13cz93uef31lr">:</span>
          <TimeBox value={minutes} label="m" data-id="element-48" data-mp="13g3mnidrv9p3" />
          <span aria-hidden="true" data-id="element-49" data-mp="18ddibfrr8hld">:</span>
          <TimeBox value={seconds} label="s" data-id="element-50" data-mp="18eesli0y5021" />
        </div>
      </div>
    </div>;
}
function TimeBox({
  value,
  label
}: {
  value: string;
  label: string;
}) {
  return <span className="rounded-lg bg-white/20 px-2 py-0.5" data-id="element-51" data-mp="yfz5rr8yccyc">
      {value}
      <span className="text-[0.65em] font-semibold" data-id="element-52" data-mp="1m407ag7pqt49">{label}</span>
    </span>;
}